import axios from 'axios';

export const headers = {
  'Content-Type': 'application/x-www-form-urlencoded',
  // This represents the client_id and the client_secret formatted as client_id:client_secret encoded in base64
  authorization: `Basic ${"YTI0MmUxMDhmZTg3NDJiYmIyMjFjOTBiMjJmZmI3MjI6"}`
};

const baseURL = `https://${"accounts.cropwise.com"}`;

export const request = axios.create({
  baseURL,
  headers: { 'Cache-Control': 'no-cache' }
});
